import { forwardRef } from 'react';

const variants = {
  primary: 'bg-green text-obsidian hover:bg-green/90 font-semibold',
  secondary: 'border border-signal/20 text-signal hover:bg-signal/5',
  ghost: 'text-steel hover:text-signal hover:bg-signal/5',
  cyan: 'bg-cyan text-obsidian hover:bg-cyan/90 font-semibold',
  violet: 'bg-violet text-white hover:bg-violet/90 font-semibold',
  gold: 'bg-gold text-obsidian hover:bg-gold/90 font-semibold',
  danger: 'bg-error text-white hover:bg-error/90 font-semibold',
};

const sizes = {
  sm: 'px-3 py-1.5 text-xs min-h-[36px]',
  md: 'px-5 py-2.5 text-sm min-h-[44px]',
  lg: 'px-8 py-3.5 text-base min-h-[48px]',
};

const Button = forwardRef(({ variant = 'primary', size = 'md', className = '', children, href, ...props }, ref) => {
  const classes = `inline-flex items-center justify-center gap-2 rounded-md font-medium transition-all duration-base ease-out-custom disabled:opacity-50 disabled:pointer-events-none ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return (
      <a ref={ref} href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }
  return (
    <button ref={ref} className={classes} {...props}>
      {children}
    </button>
  );
});

Button.displayName = 'Button';
export default Button;
